import { fetchApi } from '@/config/axiosSetting';

type VisitLocationType =
  | 'parking'
  | 'company'
  | 'repair_shop'
  | 'accident_place'
  | 'others';

type VisitResponseType = {
  name: { const: VisitLocationType; fa_const: string };
};

export const visitListRequest = (): Promise<VisitResponseType[]> => {
  return fetchApi({
    method: 'GET',
    url: 'selection_item/visit_site/wop_list/',
    params: { source: 'pwa' },
  });
};
